// extracted by mini-css-extract-plugin
export default {"date-header":"dateheader_date-header__SGj8O"};